function getPublicImage(environment, src) {
    return `https://${environment.route}/public/${src}`;
}
export default getPublicImage;
